// File: src/pages/admin/FeedbackManagement.jsx
import React, { useState, useEffect } from 'react';

export default function FeedbackManagement() {
    const [feedbacks, setFeedbacks] = useState([]);
    const [selectedFeedback, setSelectedFeedback] = useState(null);
    const [loading, setLoading] = useState(true);
    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    const fetchFeedbacks = async () => {
        const token = localStorage.getItem('skillmatch_token');
        try {
            const res = await fetch(`${API_URL}/api/admin/feedbacks`, {
                headers: { 'x-auth-token': token }
            });
            const data = await res.json();
            setFeedbacks(data);
        } catch (e) { console.error(e); } finally { setLoading(false); }
    };

    useEffect(() => { fetchFeedbacks(); }, []);

    const updateStatus = async (id, status) => {
        const token = localStorage.getItem('skillmatch_token');
        try {
            await fetch(`${API_URL}/api/admin/feedbacks/${id}/status`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                body: JSON.stringify({ status })
            });
            fetchFeedbacks(); 
            if (selectedFeedback) setSelectedFeedback(null); 
        } catch (e) { alert("Lỗi cập nhật"); }
    };

    const renderStars = (score) => {
        return [...Array(5)].map((_, i) => (
            <span key={i} className={`text-lg ${i < score ? 'text-yellow-400' : 'text-gray-300'}`}>★</span>
        ));
    };

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Phản hồi từ người dùng</h2>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <table className="w-full text-left border-collapse">
                    <thead className="bg-gray-50 border-b border-gray-200">
                        <tr>
                            <th className="p-4 text-sm font-semibold text-gray-600">Ngày gửi</th>
                            <th className="p-4 text-sm font-semibold text-gray-600">Người gửi</th>
                            <th className="p-4 text-sm font-semibold text-gray-600">Chủ đề</th>
                            <th className="p-4 text-sm font-semibold text-gray-600">Đánh giá</th>
                            <th className="p-4 text-sm font-semibold text-gray-600">Trạng thái</th>
                            <th className="p-4 text-sm font-semibold text-gray-600 text-right">Chi tiết</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? <tr><td colSpan="6" className="p-8 text-center">Đang tải...</td></tr> : feedbacks.map(fb => (
                            <tr key={fb._id} className="border-b border-gray-100 hover:bg-gray-50">
                                <td className="p-4 text-sm text-gray-500">
                                    {new Date(fb.createdAt).toLocaleDateString('vi-VN')}
                                </td>
                                <td className="p-4">
                                    <p className="font-medium text-gray-900">{fb.userId?.profile?.fullName || "Khách"}</p>
                                    <p className="text-xs text-gray-500">{fb.userId?.email || fb.email || "Ẩn danh"}</p>
                                </td>
                                <td className="p-4">
                                    <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-semibold">{fb.topic}</span>
                                </td>
                                <td className="p-4">{renderStars(fb.rating)}</td>
                                <td className="p-4">
                                    {fb.status === 'new' ? (
                                        <span className="px-2 py-1 bg-red-100 text-red-700 rounded-full text-xs font-bold">Mới</span>
                                    ) : (
                                        <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-bold">Đã xem</span>
                                    )}
                                </td>
                                <td className="p-4 text-right">
                                    <button 
                                        onClick={() => setSelectedFeedback(fb)}
                                        className="text-blue-600 hover:underline text-sm font-medium"
                                    >
                                        Xem & Xử lý
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* MODAL CHI TIẾT */}
            {selectedFeedback && (
                <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl w-full max-w-2xl p-6 shadow-2xl relative animate-scaleUp">
                        <button 
                            onClick={() => setSelectedFeedback(null)}
                            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl"
                        >
                            &times;
                        </button>

                        <h3 className="text-xl font-bold text-gray-800 mb-4">Chi tiết phản hồi</h3>
                        
                        <div className="grid grid-cols-2 gap-4 mb-6">
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <p className="text-xs text-gray-500 uppercase font-bold mb-1">Người gửi</p>
                                {/* ✅ FIX: Thêm text-gray-900 để màu chữ đen rõ ràng */}
                                <p className="font-medium text-gray-900">{selectedFeedback.userId?.email || selectedFeedback.email || "Ẩn danh"}</p>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <p className="text-xs text-gray-500 uppercase font-bold mb-1">Chủ đề</p>
                                <p className="font-medium text-blue-600">{selectedFeedback.topic}</p>
                            </div>
                        </div>

                        <div className="mb-6">
                            <p className="text-xs text-gray-500 uppercase font-bold mb-2">Nội dung</p>
                            <div className="p-4 bg-gray-50 rounded-lg text-gray-800 border border-gray-100 whitespace-pre-wrap">
                                {selectedFeedback.message}
                            </div>
                        </div>

                        {/* HIỂN THỊ ẢNH NẾU CÓ */}
                        {selectedFeedback.image && (
                            <div className="mb-6">
                                <p className="text-xs text-gray-500 uppercase font-bold mb-2">Ảnh đính kèm</p>
                                <div className="border border-gray-200 rounded-lg overflow-hidden bg-gray-100 p-2 flex justify-center">
                                    {/* ✅ FIX: Style ảnh */}
                                    <img 
                                        src={selectedFeedback.image} 
                                        alt="Evidence" 
                                        className="max-w-full h-auto max-h-[300px] object-contain rounded" 
                                        onError={(e) => { e.target.onerror = null; e.target.src = "https://via.placeholder.com/300x200?text=Lỗi+Ảnh"; }}
                                    />
                                </div>
                                <a href={selectedFeedback.image} target="_blank" rel="noreferrer" className="text-blue-600 text-xs mt-2 block hover:underline text-center">
                                    [Mở ảnh gốc trong tab mới]
                                </a>
                            </div>
                        )}

                        <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
                            {selectedFeedback.status === 'new' && (
                                <button 
                                    onClick={() => updateStatus(selectedFeedback._id, 'read')}
                                    className="px-4 py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700"
                                >
                                    Đánh dấu đã xem
                                </button>
                            )}
                            <button 
                                onClick={() => setSelectedFeedback(null)}
                                className="px-4 py-2 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200"
                            >
                                Đóng
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}